import React from 'react';
import Form from './Form';

import './style.css';

const Description = (props) => {
  return (
    <div className="description half">
      <div className="d-m-none" id="description-dest">
        <h1 className="master-class_header" itemProp="name">{props.name}</h1>
        <div className="description__text" itemProp="description" dangerouslySetInnerHTML={{ __html : props.description }} />
        <Form header={props.header}
          calendar={props.calendar}
          date={props.date}
          price={props.price} />
      </div>
      <h1 className="master-class_header d-c-none" itemProp="name">{props.name}</h1>
      <div className="description__img" dangerouslySetInnerHTML={{ __html : props.image }} />
      <div className="d-c-none">
        <div className="description__text" itemProp="description" dangerouslySetInnerHTML={{ __html : props.description }} />
          <Form header={props.header}
              calendar={props.calendar}
              date={props.date}
              price={props.price} />
      </div>
    </div>
  )
}

export default Description;